import bugsnag from "@bugsnag/js"
import { environment } from "./env"

import { IAuth } from "@bgov/auth-plugin-vue"

export const bugsnagClient = bugsnag({
  apiKey: "5bc9af5d8f511892474bf0a48d7866d7",
  releaseStage: environment,
  notifyReleaseStages: ["production", "staging"],
})

export function setupAuthHandler(authApi: IAuth) {
  authApi.$on("login", user => {
    bugsnagClient.user = {
      id: user.uuid,
      firmId: user.firmId,
      customerId: user.customerId,
      isInternal: user.isInternal,
    }
  })
}
